import { Divider, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import NotesListAddNewNoteButton from "../add-new-note-button/NotesListAddNewNoteButton";
import FilterNotesButton from "../filter-notes-button/FilterNotesButton";
import styles from "./notesListPanel.module.scss";

export interface INotesListPanelProps {
    isMobile: boolean;
    isCreateNewNoteEnable: boolean;
    content: JSX.Element;
    filterPanel: JSX.Element;
    isFilterActive: boolean;
    onAddNoteButtonClicked: () => void;
    showFiltersPanel: boolean;
    setShowFiltersPanel: (showFiltersPanel: boolean) => void;
    mobileHeight: string;
    desktopHeight: string;
}

const NotesListPanel: React.FC<INotesListPanelProps> = ({
    isMobile,
    isCreateNewNoteEnable,
    content,
    filterPanel,
    isFilterActive,
    onAddNoteButtonClicked,
    showFiltersPanel,
    setShowFiltersPanel,
    mobileHeight,
    desktopHeight
}) => {

    if (isMobile) {
        return (
            <Flex
                column
                className={styles.list}
                gap="gap.smaller"
                style={{ width: "100vw", height: mobileHeight }}
            >
                <Flex hAlign="start">
                    <FilterNotesButton
                        onClick={() => {
                            setShowFiltersPanel(!showFiltersPanel);
                        }}
                        isActive={isFilterActive}
                    />
                </Flex>
                <Divider />
                {showFiltersPanel && (
                    <>
                        {filterPanel}
                        <Divider />
                    </>
                )}
                {content}
            </Flex>
        );
    }

    return (
        <Flex gap="gap.smaller" style={{ height: desktopHeight, minWidth: "auto" }}>
            <Flex column gap="gap.small">
                <Flex hAlign="start" style={{marginBottom: "20px"}}>
                    <FilterNotesButton
                        onClick={() => {
                            setShowFiltersPanel(!showFiltersPanel);
                        }}
                        isActive={isFilterActive}
                    />
                </Flex>
                {showFiltersPanel
                    ? <Flex style={{ height: desktopHeight, minWidth: "330px", overflowY: "scroll" }}>
                        {filterPanel}
                    </Flex>
                    : <Text className={styles.verticalButton} color="brand" weight="bold">
                    Filtry
                </Text>}
            </Flex>
            <Divider vertical />
            <Flex column className={styles.list} gap="gap.smaller" style={{ height: desktopHeight, minWidth: "280px" }} >
                {isCreateNewNoteEnable && (<>
                    <Flex hAlign="start">
                        <NotesListAddNewNoteButton onClick={onAddNoteButtonClicked} />
                    </Flex>
                    <Divider />
                </>)}
                {content}
            </Flex>
        </Flex>
    );
}

export default NotesListPanel;